import graphql__e3112a2cdfbb7a28c986 from "./__generated__/FeaturedContentGrid_featuredContent.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";

import FeaturedContentBlock from "./FeaturedContentBlock";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const FeaturedContentGrid = props => {
  const { isMobile } = useResponsiveFlag();
  const { featuredContentBlocks } = props.featuredContent;

  // Only display 1 element per row for mobile
  const blocksPerRow = isMobile ? 1 : props.featuredContent.blocksPerRow;

  if (featuredContentBlocks.length === 0) return null;

  const listClassName = classNames(
    "featured-content",
    "featured-content-grid",
    "list-unstyled",
    "w-100",
    "d-flex",
    `list-${blocksPerRow}`
  );

  return (
    <ul className={listClassName}>
      {featuredContentBlocks.map(block => (
        <FeaturedContentBlock
          key={block.id}
          block={block}
        />
      ))}
    </ul>
  );
};

export default createFragmentContainer(FeaturedContentGrid, {
  featuredContent: graphql__e3112a2cdfbb7a28c986
});
